import Inputmask from 'inputmask'
const masks = {
  date: {
    mask: '99/99/9999',
    jitMasking: false,
    greedy: false,
    keepStatic: true,
    onBeforeMask(val) {
      if (val.includes('-')) return val.split('-').reverse().join('/')
    },
    onUnMask(maskedValue) {
      if (maskedValue.includes('/')) {
        return maskedValue.split('/').reverse().join('-')
      }
      return maskedValue
    },
  },
  address_number: {
    mask: '99999',
    jitMasking: true,
    keepStatic: false,
    greedy: false,
  },
  phone: {
    mask: ['9999-9999', '99999-9999'],
    jitMasking: false,
    greedy: false,
    keepStatic: true,
    autoUnmask: true,
  },
  cnpj: {
    mask: '99.999.999/9999-99',
    jitMasking: false,
    greedy: false,
    keepStatic: true,
    autoUnmask: true,
  },
  landline: {
    mask: '9999-9999',
    jitMasking: false,
    greedy: false,
    keepStatic: true,
    autoUnmask: true,
  },
  mobile: {
    mask: '99999-9999',
    jitMasking: false,
    greedy: false,
    keepStatic: true,
    autoUnmask: true,
  },
  ddd: {
    mask: '(99)',
    jitMasking: false,
    greedy: false,
    keepStatic: true,
    autoUnmask: true,
  },
  cpf: {
    mask: '999.999.999-99',
    jitMasking: false,
    greedy: false,
    keepStatic: true,
    autoUnmask: true,
  },
  cep: {
    mask: '99999-999',
    jitMasking: false,
    greedy: false,
    keepStatic: true,
    autoUnmask: true,
  },
  percentage: {
    alias: 'decimal',
    suffix: '%',
    autoGroup: true,
    digits: 2,
    digitsOptional: false,
    min: 0,
    max: 100,
    radixPoint: ',',
    // groupSeparator: '.',
    autoUnmask: true,
    rightAlign: false,
  },
  money: {
    alias: 'currency',
    prefix: 'R$ ',
    min: 0,
    max: 9999999999,
    radixPoint: ',',
    groupSeparator: '.',
    rightAlign: false,
    autoUnmask: true,
    onBeforeMask(val) {
      return val.toString().replace('.', ',')
    },
    onUnMask(maskedValue) {
      return maskedValue
        .replace('R$ ', '')
        .split('.')
        .join('')
        .split(',')
        .join('.')
    },
  },
  number: {
    mask: '9999999999999',
    jitMasking: true,
    greedy: false,
    rightAlign: false,
  },
  rg: {
    // mask: '9{1,2}.9{3}.9{3}[-*]',
    mask: '9999999[9999]',
    jitMasking: true,
    greedy: false,
    keepStatic: true,
    autoUnmask: true,
    casing: 'upper',
  },
  age: {
    mask: '999',
    jitMasking: true,
    greedy: false,
    keepStatic: true,
    autoUnmask: true,
  },
  dddPhone: {
    mask: ['(99) 9999-9999', '0800 999 9999', '(99) 99999-9999'],
    autoUnmask: true,
    keepStatic: true,
    jitMasking: false,
  },
  get phones() {
    return {
      mask: ['(99) 9999-9999', '(99) 99999-9999'],
      jitMasking: false,
      greedy: false,
      keepStatic: true,
      autoUnmask: false,

      /*   do cep
      jitMasking: false,
      greedy: false,
      keepStatic: true,
      autoUnmask: true, */
    }
  },
}

export default masks

/**
 * Aplica uma máscara a um valor, e retorna o valor mascarado
 * @param {String} stringToMask - String a ser aplicada a máscara
 * @param {String} maskName - Nome da máscara (vide dicionário de máscaras)
 * @returns {String} - String mascarada
 */
export const getMaskedValue = (stringToMask, maskName) => {
  return Inputmask.format(stringToMask, masks[maskName])
}
